import { TenantOption } from "common/dto/TenantOption";
import { User } from "model/user.model";
import { UserConfiguration } from "model/user-configuration.model";

/** ---- Dispatch Types ---- */
export const LOGIN_STATUS_START = "LOGIN_STATUS_START";
export const LOGIN_STATUS_PARSING_PASSPORT = "LOGIN_STATUS_PARSING_PASSPORT";
export const LOGIN_STATUS_RETRIEVING = "LOGIN_STATUS_RETRIEVING";
export const LOGIN_STATUS_TENANT_OPTIONS = "LOGIN_STATUS_TENANT_OPTIONS";
export const LOGIN_STATUS_LOGGING_IN = "LOGIN_STATUS_LOGGING_IN";
export const LOGIN_STATUS_SUCCESS = "LOGIN_STATUS_SUCCESS";
export const LOGIN_STATUS_ERROR = "LOGIN_STATUS_ERROR";
export const LOGIN_STATUS_NO_LICENCE = "LOGIN_STATUS_NO_LICENCE";

// Describing the different ACTION NAMES available
export const LOGIN_PASSPORT_CALLBACK = "LOGIN_PASSPORT_CALLBACK";
export const LOGIN_EMR_SERVER = "LOGIN_EMR_SERVER";
export const LOGIN_EMR_SERVER_FETCHING = "LOGIN_EMR_SERVER_FETCHING";
export const LOGIN_EMR_SERVER_TENANT_OPTIONS =
  "LOGIN_EMR_SERVER_TENANT_OPTIONS";
export const LOGIN_EMR_SERVER_SUCCESS = "LOGIN_EMR_SERVER_SUCCESS";
export const LOGIN_EMR_SERVER_ERROR = "LOGIN_EMR_SERVER_ERROR";
export const LOGIN_EMR_NO_LICENSE = "LOGIN_EMR_NO_LICENSE";
export const LOGOUT_UNAUTHORIZED = "LOGOUT_UNAUTHORIZED";
export const LOGIN_STS_RECEIVED = "LOGIN_STS_RECEIVED";

export const LOAD_TARIFICATION_SETTINGS = "LOAD_TARIFICATION_SETTINGS";

export const SET_USER_CONFIGURATION = "SET_USER_CONFIGURATION";

/** ---- Dispatch Interfaces ---- */
export interface LoginSuccess {
  user: User;
  practice: string;
  accessToken: string;
  userConfiguration: UserConfiguration;
}

export interface NoLicense {
  loginError: string;
  licenseUrl: string;
}

interface LoginStsReceived {
  type: typeof LOGIN_STS_RECEIVED;
  payload: string;
}

interface LoginPassportCallback {
  type: typeof LOGIN_PASSPORT_CALLBACK;
  payload: { idToken: string; state: any };
}

interface LoginEMRServer {
  type: typeof LOGIN_EMR_SERVER;
  payload: string;
}

interface LoginEmrServerFetching {
  type: typeof LOGIN_EMR_SERVER_FETCHING;
}

interface LoginEmrServerTenantOptions {
  type: typeof LOGIN_EMR_SERVER_TENANT_OPTIONS;
  payload: Array<TenantOption>;
}

interface LoginEMRServerSuccess {
  type: typeof LOGIN_EMR_SERVER_SUCCESS;
  payload: LoginSuccess;
}

interface LogoutUnauthorized {
  type: typeof LOGOUT_UNAUTHORIZED;
}

interface LoginEMRServerError {
  type: typeof LOGIN_EMR_SERVER_ERROR;
  payload: string;
}

interface LoginEMRNoLicense {
  type: typeof LOGIN_EMR_NO_LICENSE;
  payload: NoLicense;
}

interface LoadTarificationSettings {
  type: typeof LOAD_TARIFICATION_SETTINGS;
  payload: boolean;
}

interface SetUserConfiguration {
  type: typeof SET_USER_CONFIGURATION;
  payload: UserConfiguration;
}

export type UserContextLoginStatus =
  | typeof LOGIN_STATUS_START
  | typeof LOGIN_STATUS_PARSING_PASSPORT
  | typeof LOGIN_STATUS_LOGGING_IN
  | typeof LOGIN_STATUS_RETRIEVING
  | typeof LOGIN_STATUS_TENANT_OPTIONS
  | typeof LOGIN_STATUS_SUCCESS
  | typeof LOGIN_STATUS_ERROR
  | typeof LOGIN_STATUS_NO_LICENCE
  | typeof LOGIN_STS_RECEIVED
  | typeof LOAD_TARIFICATION_SETTINGS
  | typeof SET_USER_CONFIGURATION;

export type UserContextActionTypes =
  | LoginStsReceived
  | LoginEMRServer
  | LoginEMRServerSuccess
  | LoginEmrServerFetching
  | LoginEmrServerTenantOptions
  | LoginEMRServerError
  | LoginPassportCallback
  | LogoutUnauthorized
  | LoginEMRNoLicense
  | LoadTarificationSettings
  | SetUserConfiguration;
